import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';

// Firebase Functions 초기화
const functions = getFunctions(getApp(), 'us-central1');

// 주장 평가 함수
export async function evaluateArgument(argument, topic, position, currentRound, opponentArgument) {
  try {
    // Firebase Function 호출
    const evaluateArgumentFunction = httpsCallable(functions, 'evaluateArgumentDetailed');
    
    const result = await evaluateArgumentFunction({
      argument: argument,
      topic: topic,
      position: position,
      currentRound: currentRound,
      opponentArgument: opponentArgument
    });

    return result.data.evaluation || getDefaultEvaluation();

  } catch (error) {
    console.error('AI 평가 오류:', error);
    return getDefaultEvaluation();
  }
}

// 기본 평가 응답 (API 호출 실패 시 사용)
function getDefaultEvaluation() {
  return `
**논리적 구조 분석**
이 주장은 명확한 전제-결론 구조를 가지고 있으며, 논리적 연결고리가 체계적으로 구성되어 있습니다. 주요 논점들이 순차적으로 전개되면서 전체적인 논증의 일관성을 유지하고 있습니다.

**근거 및 증거 검토**
제시된 근거들은 주장의 핵심을 효과적으로 뒷받침하고 있습니다. 구체적인 사례와 통계 자료를 활용하여 논증의 신뢰성을 높였으며, 다각도의 관점에서 접근한 근거들이 균형있게 배치되어 있습니다.

**사실성 및 객관성 평가**
주장에 포함된 정보들은 검증 가능한 사실에 기반하고 있으며, 주관적 의견과 객관적 사실이 명확히 구분되어 제시되었습니다. 인용된 자료들의 출처가 신뢰할 만하며, 편향되지 않은 관점을 유지하고 있습니다.

**논증 기법 및 수사법 분석**
효과적인 수사 기법을 활용하여 청중의 관심을 끌고 있으며, 감정적 호소와 논리적 설득이 적절히 조화를 이루고 있습니다. 반대 의견에 대한 예상 반박도 고려하여 논증의 완성도를 높였습니다.

**토론 맥락에서의 효과성**
현재 토론의 흐름과 이전 주장들을 고려할 때, 이 주장은 토론의 방향성을 명확히 제시하고 있으며, 상대방의 논점에 대한 효과적인 대응을 포함하고 있습니다.

※ AI 분석 서비스에 일시적인 문제가 발생하여 기본 평가를 표시합니다.
  `;
}

// 기존 함수들도 유지
export async function generateCounterArgument(topic, previousArguments, position) {
  try {
    const generateCounterFunction = httpsCallable(functions, 'generateCounterArgument');
    
    const result = await generateCounterFunction({
      topic: topic,
      previousArguments: previousArguments,
      position: position
    });

    return result.data.counterArgument || `${position} 입장에서의 반박 주장입니다. 이전 주장들을 분석한 결과, 다음과 같은 논리적 반박이 가능합니다...`;

  } catch (error) {
    console.error('반박 주장 생성 오류:', error);
    return `${position} 입장에서의 반박 주장입니다. 이전 주장들을 분석한 결과, 다음과 같은 논리적 반박이 가능합니다...`;
  }
}